// Offline demo mode (OFF by default; enable with localStorage 'qlipper-web:demo'='1'
// and 'qlipper-web:bridge'='mock'). Lets the FULL UI pipeline run with zero external
// inputs — mock download (sample.mp4) + canned analysis (no Gemini key) + real render —
// purely to verify the real App.jsx flow and to give a previewable demo. Real YouTube +
// real Gemini still use the live bridge + the user's key when demo is off.

export function isDemo() {
  try { return localStorage.getItem('qlipper-web:demo') === '1'; } catch { return false; }
}

// A canned analysis matching the analyzeForClips() output shape, sized to the source.
export function cannedAnalysis(durationSec = 5, title = 'Demo') {
  const d = Math.max(2, durationSec);
  const half = d / 2;
  return {
    video_clips: [
      { clip_id: '1', start: 0, end: Math.min(half, d), topic: 'Demo Clip 1',
        reason: 'offline demo (no Gemini call)', hook: 'INI HASIL QLIPPER WEB' },
      { clip_id: '2', start: Math.min(half, d - 0.1), end: d, topic: 'Demo Clip 2',
        reason: 'offline demo (no Gemini call)', hook: 'CLIP KEDUA OTOMATIS' },
    ],
    source_info: { video_title: title },
  };
}
